import {
  useGetHandlers,
  useGetHandlersCount,
  useGetHandler,
  useCreateHandler,
  usePutHandler,
} from '@vlabs/api/artemy/client';

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export function useHandlersList(params) {
  return useGetHandlers(params);
}

export function useHandlersCount(params) {
  return useGetHandlersCount(params);
}

export function useHandlerById(handlerId) {
  return useGetHandler(handlerId, {
    query: { enabled: !!handlerId },
  });
}

export function useCreateHandlerMutation(options) {
  return useCreateHandler({
    ...options,
  });
}

export function useUpdateHandlerMutation(options) {
  return usePutHandler({
    ...options,
  });
}
